import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect } from 'react';
import { TextInput, themeGet, useTheme } from '@primer/react';
import styled from 'styled-components';
import XFilledIcon from '../../icons/XFilledIcon.js';
import SearchIcon from '../../icons/SearchIcon.js';
import { isEnterOrSpacePressed } from '../../utils/functions.js';
import './index.css.js';
import LTTooltip from '../LTTooltip/index.js';
import LTIconButton from '../LTIconButton/index.js';
import { ColorSchemes } from '../../utils/constants.js';

var InputBox = styled(TextInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  border-color: ", ";\n  width: 100%;\n  > input {\n    overflow: auto;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n  > input::placeholder {\n    font-size: 14px;\n    color: ", ";\n  }\n  &:focus-within {\n    background-color: #fff; // Was Issue with Dark Theme\n    border-color: ", ";\n    box-shadow: ", " 0px 0px 0px 1px inset;\n  }\n"], ["\n  ", "\n  ", "\n  border-color: ", ";\n  width: 100%;\n  > input {\n    overflow: auto;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n  > input::placeholder {\n    font-size: 14px;\n    color: ", ";\n  }\n  &:focus-within {\n    background-color: #fff; // Was Issue with Dark Theme\n    border-color: ", ";\n    box-shadow: ", " 0px 0px 0px 1px inset;\n  }\n"])), function (_a) {
  var colorVariant = _a.colorVariant;
  return colorVariant === LTTextInput.Variant.DEFAULT ? "background-color: #f7f7f7;" : "background-color: #ffffff;";
}, function (_a) {
  var size = _a.size;
  return size === LTTextInput.Size.SMALL ? "height: 28px;" : size === LTTextInput.Size.MEDIUM ? "height: 32px;" : "height: 40px;";
}, themeGet("colors.border.default"), themeGet("colors.fg.muted"), themeGet("colors.focus.outlineColor"), themeGet("colors.focus.outlineColor"));
var LTTextInput = function LTTextInput(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "Search" : _b,
    _c = _a.allowClearSearch,
    allowClearSearch = _c === void 0 ? true : _c,
    _d = _a.autoCompleteType,
    autoCompleteType = _d === void 0 ? "off" : _d,
    _e = _a.className,
    className = _e === void 0 ? "" : _e,
    _f = _a.containsLabelElement,
    containsLabelElement = _f === void 0 ? false : _f,
    _g = _a.defaultValue,
    defaultValue = _g === void 0 ? "" : _g,
    _h = _a.disabled,
    disabled = _h === void 0 ? false : _h,
    _j = _a.extraStyle,
    extraStyle = _j === void 0 ? {} : _j,
    _k = _a.forwardRef,
    forwardRef = _k === void 0 ? null : _k,
    _l = _a.inputOnly,
    inputOnly = _l === void 0 ? false : _l,
    _m = _a.colorScheme,
    colorScheme = _m === void 0 ? LTTextInput.colorScheme.LIGHT : _m,
    _o = _a.loaderPosition,
    loaderPosition = _o === void 0 ? LTTextInput.LoaderPosition.TRAILING : _o,
    _p = _a.loading,
    loading = _p === void 0 ? null : _p,
    _q = _a.leadingIcon,
    leadingIcon = _q === void 0 ? SearchIcon : _q,
    _r = _a.maxLength,
    maxLength = _r === void 0 ? undefined : _r,
    _s = _a.name,
    name = _s === void 0 ? "search" : _s,
    _t = _a.onChange,
    onChange = _t === void 0 ? function () {} : _t,
    _u = _a.placeholder,
    placeholder = _u === void 0 ? "" : _u,
    _v = _a.size,
    size = _v === void 0 ? LTTextInput.Size.SMALL : _v,
    _w = _a.tabIndex,
    tabIndex = _w === void 0 ? "0" : _w,
    _x = _a.trailingAction,
    trailingAction = _x === void 0 ? function () {} : _x,
    trailingActionComponent = _a.trailingActionComponent,
    _y = _a.tooltipDirectionTrailingAction,
    tooltipDirectionTrailingAction = _y === void 0 ? "sw" : _y,
    _z = _a.type,
    type = _z === void 0 ? "text" : _z,
    _0 = _a.value,
    value = _0 === void 0 ? "" : _0,
    _1 = _a.validationStatus,
    validationStatus = _1 === void 0 ? "" : _1,
    _2 = _a.variant,
    variant = _2 === void 0 ? LTTextInput.Variant.DEFAULT : _2,
    onKeyUp = _a.onKeyUp,
    rest = __rest(_a, ["ariaLabel", "allowClearSearch", "autoCompleteType", "className", "containsLabelElement", "defaultValue", "disabled", "extraStyle", "forwardRef", "inputOnly", "colorScheme", "loaderPosition", "loading", "leadingIcon", "maxLength", "name", "onChange", "placeholder", "size", "tabIndex", "trailingAction", "trailingActionComponent", "tooltipDirectionTrailingAction", "type", "value", "validationStatus", "variant", "onKeyUp"]);
  var _3 = useState(value),
    text = _3[0],
    setText = _3[1];
  var _inputRef = useRef();
  var inputRef = forwardRef || _inputRef;
  var themeData = useTheme();
  useEffect(function () {
    setText(value);
  }, [value]);
  var handleChange = function handleChange(e) {
    setText(e.target.value);
    onChange(e.target.value, e); // pass only events
  };

  var handleTrailingClick = function handleTrailingClick() {
    var _a;
    setText("");
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    trailingAction();
  };
  var getTrailingActionJsx = function getTrailingActionJsx() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, ColorSchemes.LIGHT_HIGH_CONTRAST === (themeData === null || themeData === void 0 ? void 0 : themeData.colorScheme) ? /*#__PURE__*/React.createElement(LTTooltip, {
      text: "Clear Input"
    }, /*#__PURE__*/React.createElement(LTIconButton, {
      ariaLabel: "Clear input",
      customStyle: {
        marginRight: themeGet("space.1"),
        height: "auto"
      },
      icon: XFilledIcon,
      onClick: handleTrailingClick,
      size: LTIconButton.Size.SMALL,
      tabIndex: tabIndex,
      variant: LTIconButton.IconButtonVariants.INVISIBLE
    })) : /*#__PURE__*/React.createElement(TextInput.Action, {
      sx: {
        marginRight: themeGet("space.1")
      },
      onClick: handleTrailingClick,
      onKeyDown: function onKeyDown(e) {
        if (isEnterOrSpacePressed(e, true)) {
          handleTrailingClick();
        }
      },
      icon: XFilledIcon,
      tooltipDirection: tooltipDirectionTrailingAction,
      "aria-label": "Clear input",
      tabIndex: tabIndex
    }));
  };
  var trailingActionJsx = null;
  if (text) {
    // If there's a custom trailing action component provided by the product
    if (trailingActionComponent) {
      trailingActionJsx = trailingActionComponent; // Use the provided custom component with icon and handler
    }

    if (!trailingActionJsx) {
      var showTrailingActionIcon = !disabled && allowClearSearch;
      trailingActionJsx = showTrailingActionIcon && getTrailingActionJsx();
    }
  }
  return /*#__PURE__*/React.createElement(InputBox, __assign({
    "aria-label": !containsLabelElement ? ariaLabel : undefined,
    autoComplete: autoCompleteType,
    className: "".concat(colorScheme === LTTextInput.colorScheme.DARK ? "ltBlackSearch" : "", " ").concat(className),
    colorVariant: variant,
    sx: __assign({}, extraStyle),
    disabled: disabled,
    leadingVisual: inputOnly ? null : leadingIcon,
    name: name,
    loading: loading,
    maxLength: maxLength,
    ref: inputRef,
    placeholder: placeholder,
    size: size,
    onChange: handleChange,
    defaultValue: defaultValue,
    loaderPosition: loaderPosition,
    value: text,
    validationStatus: validationStatus,
    type: type,
    tabIndex: tabIndex,
    onKeyUp: onKeyUp,
    trailingAction: trailingActionJsx
  }, rest));
};
LTTextInput.Size = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};
LTTextInput.colorScheme = {
  LIGHT: "light",
  DARK: "dark"
};
LTTextInput.LoaderPosition = {
  AUTO: "auto",
  LEADING: "leading",
  TRAILING: "trailing"
};
LTTextInput.Variant = {
  DEFAULT: "default",
  WHITE: "white"
};
var templateObject_1;

export { LTTextInput, LTTextInput as default };
